import type {BioIconProps} from './common-types'

export function LastPurchasedIndicatorIcon({...attributes}: BioIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <circle cx="10" cy="10" r="10" fill="#BBF7D0" />
      <circle cx="10" cy="10" r="5" fill="#22C55E" />
    </svg>
  )
}
